"use client";
import React from "react";

export const FooterMenuColumn = ({ title, items }) => {
  return (
    <nav>
      <h2 className="mb-5 text-lg font-semibold text-white">{title}</h2>
      <ul className="flex flex-col gap-4">
        {items.map((item, index) => (
          <li key={index}>
            <a
              href="#"
              className="text-base cursor-pointer text-zinc-200 hover:text-white transition-colors"
            >
              {item}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};
